var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vimeo-player',{ref:"player",attrs:{"video-id":_vm.module.video.content,"player-height":_vm.$vuetify.breakpoint.mobile ? '200px' : '500px',"options":_vm.options},on:{"ready":_vm.onReady,"play":_vm.play,"fullscreenchange":_vm.onFullscreenchange,"pause":_vm.pause,"mute":_vm.onMute,"ended":_vm.onEnded}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }